import styled from 'styled-components';

export const Label = styled.label<any>`
  cursor: pointer;
  color: ${(props) => (props.newUi ? 'var(--color-indigo-t11)' : '#3A4451')};
  display: flex;
  align-items: center;

  a {
    font-weight: 600;
    font-size: 16px;
    line-height: 26px;
    text-decoration-line: underline;
    color: var(--color-tangerine);
  }

  ${(props) => props.disabled && `pointer-events: none;`}
`;

export const CheckboxContainer = styled.div`
  display: inline-block;
  vertical-align: middle;
  margin-right: 10px;
`;

export const Icon = styled.svg<{ newUi?: boolean }>`
  fill: ${(props) => (props.newUi ? 'var(--color-indigo)' : '#007b88')};
  width: 14px;
  opacity: 0;
`;

export const HiddenCheckbox = styled.input<any>`
  border: 0;
  clip: rect(0 0 0 0);
  clippath: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;

export const StyledCheckbox = styled.div<any>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  background: white;
  border-radius: 4px;
  transition: all 150ms;
  border: 1px solid;
  border-color: ${(props) => (props.newUi ? 'var(--color-indigo-t11)' : '#3A4451')};
  ${(props) => props.disabled && `border-color: #607187;`}

  ${HiddenCheckbox}:focus + & {
    border-color: #E0AE71;
    box-shadow: 0 0 0 2px #F5E4D0;
    ${(props) => props.disabled && `border-color: #607187;`}
  }

  ${HiddenCheckbox}:checked + & ${Icon} {
    opacity: 1;
  }

  ${Label}:hover & {
    border-color: #A0AAB7;

    & ${Icon} {
      fill: #007B88;
      ${(props) => props.disabled && `fill: #607187;`}
    }
    ${(props) => props.disabled && `border-color: none;`}
  }

  ${Label} & {
    & ${Icon} {
      ${(props) => props.disabled && `fill: #607187;`}
    }
  }

  ${(props) => props.disabled && `background: #DFE3E7;`}
`;
